import { Dispatch } from "react";
import { react } from "uikit";

interface Context {
	name: string;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid = !!this.context?.name?.trim().length;

		if (!isValid) this.context?.setError(true);

		return isValid;
	}
}
